const isValidOpeningHoursItem = (entry)=>{
    return !!entry && entry.open !== null && entry.close !== null;
};
const convertToValidOpeningHours = (dayOpeningHours)=>{
    return (dayOpeningHours || []).reduce((collection, item)=>{
        if (isValidOpeningHoursItem(item)) {
            collection.push({
                open: item.open,
                close: item.close
            });
        }
        return collection;
    }, []);
};

export { convertToValidOpeningHours, isValidOpeningHoursItem };
//# sourceMappingURL=convert-to-valid-opening-hours.js.map
